var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 20C19.5523 20 20 19.5523 20 19C20 18.4477 19.5523 18 19 18C18.4477 18 18 18.4477 18 19C18 19.5523 18.4477 20 19 20ZM19 22C20.6569 22 22 20.6569 22 19C22 17.3431 20.6569 16 19 16C17.3431 16 16 17.3431 16 19C16 20.6569 17.3431 22 19 22Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 4C14.1193 4 13 5.11929 13 6.5V17.5C13 19.9853 10.9853 22 8.5 22C6.01472 22 4 19.9853 4 17.5V10C4 9.44772 4.44772 9 5 9C5.55228 9 6 9.44772 6 10V17.5C6 18.8807 7.11929 20 8.5 20C9.88071 20 11 18.8807 11 17.5V6.5C11 4.01472 13.0147 2 15.5 2C17.9853 2 20 4.01472 20 6.5V13C20 13.5523 19.5523 14 19 14C18.4477 14 18 13.5523 18 13V6.5C18 5.11929 16.8807 4 15.5 4Z",
    fill: "#777E91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13622 2.48075C4.5221 1.81924 5.4779 1.81924 5.86378 2.48075L7.62274 5.49612C8.01163 6.16277 7.53076 6.99998 6.75896 6.99998H3.24104C2.46925 6.99998 1.98838 6.16277 2.37726 5.49611L4.13622 2.48075Z",
    fill: "#777E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExp);
export default __webpack_public_path__ + "static/media/exp.efedff06d3e9d5c896f473327fac0002.svg";
export { ForwardRef as ReactComponent };